import React from "react";

const SvgIcnEdit = props => (
  <svg data-name="\u30EC\u30A4\u30E4\u30FC 1" width={24} height={24} {...props}>
    <path
      d="M6 15l3 3 9-9-3-3zm-3 6l5-2-3-3zM18 3l-2 2 3 3 2-2z"
      fill="#4a4b4c"
      fillRule="evenodd"
    />
  </svg>
);

export default SvgIcnEdit;
